import { endpoints } from "./endpoints";
import { EnvironmentModel, MXURLS } from "./environment.modal";

export const MX: MXURLS = {
  notificationServiceBaseURL:
    "https://notify-train-gateway.manifestmedex.org",
};
export const environment: EnvironmentModel = {
  production: false,
  endPoints: endpoints,
};
